module.exports = __webpack_public_path__ + "static/img/3DPPT_LOGO_WHITE.d68fe7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3DPPT_LOGO_WHITE.png
// module id = KXY3
// module chunks = 13